import { AbstractControl, ValidationErrors, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { validatePolish } from 'validate-polish';
import { Injectable } from '@angular/core';
import { ContractorService } from '@core/contractors';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContractorValidator {
    constructor(
        private readonly contractorService: ContractorService
    ) {}

    public static nipValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value?.match(/[^0-9]+/)) {
                return { invalidNipOnlyDigitsAllowed: { value: control.value } };
            }

            if (!validatePolish.nip(String(control.value))) {
                return { invalidNip: { value: control.value } };
            }

            return null;
        };
    }

    public contractorExistsValidator(originalNip?: string): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (originalNip && control.value === originalNip) {
                return of(null);
            }

            return this.contractorService.contractorExists(control.value).pipe(
                map(exists => exists ? { invalidNipAlreadyExists: true } : null)
            );
        };
    }
}
